import { render, staticRenderFns } from "./SortControl.vue?vue&type=template&id=35b0fb1e&scoped=true&functional=true&"
import script from "./SortControl.vue?vue&type=script&lang=js&"
export * from "./SortControl.vue?vue&type=script&lang=js&"
import style0 from "./SortControl.vue?vue&type=style&index=0&id=35b0fb1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "35b0fb1e",
  null
  
)

export default component.exports